import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import styled from "styled-components";
import DashInfo from "./DashInfo";
import LockerStat from "./LockerStat";
import Visits from "./Visits";
import RegistrationLog from "./RegistrationLog";
import VisitLog from "./VisitLog";
import { useEffect, useState } from "react";
import { useCrudForm } from "../../api/useCrudForm";
import { endpoints } from "../../api/endpoints";

const FlexBoxColumn = styled(Box)`
    display: flex;
    flex-direction: column;
    gap: 16px;
    width: 100%;
`;

const Dashboard = () => {
    const [isLoading, setIsLoading] = useState<boolean>(true)
    const [registerCount, setRegisterCount] = useState()
    const [visitCount, setVisitCount] = useState()
    const [visitorCount, setVisitorCount] = useState()

    const [availableData, setAvailableData] = useState()
    const [holdData, setHoldData] = useState<any>()
    const [occupiedData, setOccupiedData] = useState<any>()
    const [totalLocker, setTotalLocker] = useState()
    const [lockerStatusList, setLockerStatusList] = useState<any>()

    const [weeklyData, setWeeklyData] = useState<any>()

    const [registrationData, setRegistrationData] = useState<any>()

    const { get } = useCrudForm()

    useEffect(() => {
        setIsLoading(true)
        get({
            endpoints: endpoints.dashboard.dashInfo,
            onSuccess: (res: any) => {
                setRegisterCount(res.data?.dashboardActivity?.todayRegisterCount)
                setVisitCount(res.data?.dashboardActivity?.todayVisitCount)
                setVisitorCount(res.data?.dashboardActivity?.todayVisitors)

                setAvailableData(res.data?.lockerStatus?.availableLockerCount)
                setHoldData(res.data?.lockerStatus?.holdLockerCount)
                setOccupiedData(res.data?.lockerStatus?.occupiedLockerCount)
                setTotalLocker(res.data?.lockerStatus?.totalLocker)

                setLockerStatusList(res.data?.lockerStatusList)

                setWeeklyData(res.data?.weeklyVisitCount)
                setRegistrationData(res.data?.weeklyRegisterCount)
                setIsLoading(false)
            },
            onError: (error: any) => {
                console.log(error);
                setIsLoading(false)
            }
        })
    }, []);

    return (
        <Box>
            <Typography variant="h5" component="h5" mb={1} fontWeight={600}>
                Dashboard
            </Typography>
            <Box sx={{ display: "flex" }}>
                <DashInfo isLoading={isLoading} registerCount={registerCount} visitCount={visitCount} visitorCount={visitorCount} />
            </Box>
            <Grid container spacing={2} paddingTop={2}>
                <Grid item xs={6}>
                    <FlexBoxColumn>
                        <LockerStat isLoading={isLoading} availableData={availableData} holdData={holdData} occupiedData={occupiedData} totalLocker={totalLocker} lockerStatusList={lockerStatusList} />
                        <VisitLog />
                    </FlexBoxColumn>
                </Grid>

                <Grid item xs={6}>
                    <FlexBoxColumn>
                        <Visits isLoading={isLoading} weeklyData={weeklyData} />
                        <RegistrationLog registrationData={registrationData} />
                    </FlexBoxColumn>
                </Grid>
            </Grid>
        </Box>
    );
}

export default Dashboard;
